(function ($) {

  // ---------- APP START
  window.App = {

    config: {
      scrollOffset: 0
    },

    init: function () {
      // Init SVG polyfill
      if (typeof (svg4everybody) !== 'undefined') svg4everybody();

      // Init object-fill polyfill
      if (typeof (objectFitImages) !== 'undefined') objectFitImages();

      // Remove focus state when clicking on a button with a mouse
      $(':not(form) button, a').on('click', function (e) {
        if (e.clientX && e.clientY)
          $(this).trigger('blur');
      });

      $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

        if ($(scrollTo).length > 0 && $(this).data('prevent-scroll') !== true)
          App.scroll(scrollTo, $(this).data('scroll-offset'));
      });

      $('.footer-nav__back-to-top').on('click', function () {
        App.scroll('body');
      });

      App.initClickableDivs();
      App.initHeader();
      App.eventTracking();
    },

    load: function () {
      function gtag() { dataLayer.push(arguments); }
      if (window.ga === undefined) {
        window.ga = function () { };
      }
      if (window.location.pathname == '/demander-un-devis/') {
        window.dataLayer = window.dataLayer || [];
        gtag('event', 'conversion', { 'send_to': 'AW-740396774/D0u1CLCa1qEDEOadhuEC' });
      }
    },

    // Make div (with eventually child links) clickable
    initClickableDivs: function (context) {
      var clickableDivs;

      if (context === undefined) {
        clickableDivs = $('[data-href]');
      } else if (context.data('href')) {
        clickableDivs = context;
      } else {
        clickableDivs = context.find('[data-href]');
      }

      var enable = true;

      clickableDivs.on('click', function () {
        if (enable) {
          if ($(this).data('href-target') == '_blank') {
            window.open($(this).data('href'), '_blank');
          } else {
            document.location.href = $(this).data('href');
          }
        }
      }).find('a').on('click', function (e) {
        if (enable) {
          e.stopPropagation();
        }
      });
    },

    scroll: function (element, offset) {
      offset = offset === undefined ? App.config.scrollOffset : offset;

      $('html, body').animate({ scrollTop: $(element).offset().top - offset }, 'slow');
    },

    sendEvent: function (eventCategory, eventAction, eventLabel) {
      // if (typeof ga == 'function') {
      //   ga('send', 'event', eventCategory, eventAction, eventLabel, { transport: 'beacon' });
      // }
      if (typeof gtag == "function") {
        gtag('event', eventAction, { 'event_category': eventCategory, 'event_label': eventLabel, 'send_to': 'G-4NNHYGX1BR'});
      }
      window._mtm.push({ 'event': 'customEvent', 'event_category': eventCategory, 'event_action': eventAction, 'event_label': eventLabel });
    },

    eventTracking: function () {
      $('.header__social-links .facebook-link').on('click', function () {
        App.sendEvent('clic-header', 'Facebook', $(this).attr('href'));
      });
      $('.header__social-links .instagram-link').on('click', function () {
        App.sendEvent('clic-header', 'Instagram', $(this).attr('href'));
      });
      $('.header__social-links .youtube-link').on('click', function () {
        App.sendEvent('clic-header', 'Youtube', $(this).attr('href'));
      });
      $('.header__social-links .linkedin-link').on('click', function () {
        App.sendEvent('clic-header', 'LinkedIn', $(this).attr('href'));
      });
      $('.header__social-links .pinterest-link').on('click', function () {
        App.sendEvent('clic-header', 'Pinterest', $(this).attr('href'));
      });
      $('.rs-menu__item .facebook-link').on('click', function () {
        App.sendEvent('clic-footer', 'Facebook', $(this).attr('href'));
      });
      $('.rs-menu__item .instagram-link').on('click', function () {
        App.sendEvent('clic-footer', 'Instagram', $(this).attr('href'));
      });
      $('.rs-menu__item .youtube-link').on('click', function () {
        App.sendEvent('clic-footer', 'Youtube', $(this).attr('href'));
      });
      $('.rs-menu__item .linkedin-link').on('click', function () {
        App.sendEvent('clic-footer', 'LinkedIn', $(this).attr('href'));
      });
      $('.rs-menu__item .pinterest-link').on('click', function () {
        App.sendEvent('clic-footer', 'Pinterest', $(this).attr('href'));
      });
      $('.header__quote-btn.m--blue a').on('click', function () {
        App.sendEvent('clic-header', 'clic-CTA-prendre-rendez-vous', 'CTA-prendre-rendez-vous');
      });
      $('.header__quote-btn:not(.m--blue) a').on('click', function () {
        App.sendEvent('clic-header', 'clic-CTA-demander-un-devis', 'CTA-demander-un-devis');
      });
      $('.product-head .btn').on('click', function () {
        App.sendEvent('clic-page-produit', 'clic-CTA-demander-un-devis', 'CTA-demander-un-devis');
      });
      $('.footer-cta .btn:nth-child(1)').on('click', function () {
        App.sendEvent('clic-footer', 'clic-CTA-demander-un-devis', 'CTA-demander-un-devis');
      });
      $('.footer-cta .btn:nth-child(2)').on('click', function () {
        App.sendEvent('clic-footer', 'clic-CTA-prendre-rendez-vous', 'CTA-prendre-rendez-vous');
      });
      $('.footer-cta .btn:nth-child(3)').on('click', function () {
        App.sendEvent('clic-footer', 'clic-CTA-demander-un-catalogue', 'CTA-demander-un-catalogue');
      });
      $('.home-double-img__second-line .btn').on('click', function () {
        App.sendEvent('clic-home', 'clic-CTA-demander-un-devis', 'CTA-demander-un-devis');
      });
      $('.call-cta__button').on('click', function () {
        App.sendEvent('clic-picto-phone', 'clic-picto-phone', 'clic-picto-phone');
      });
      $('.shop-map__mail-btn').on('click', function () {
        App.sendEvent('clic-trouver-nos-agences', 'clic-CTA-envoyer-un-email', $(this).data('agency'));
      });
      $('.shop-map__appointment-btn').on('click', function () {
        App.sendEvent('clic-trouver-nos-agences', 'clic-CTA-prendre-rendez-vous', $(this).data('agency'));
      });
      $('.shop-map__agency-btn').on('click', function () {
        App.sendEvent('clic-trouver-nos-agences', 'clic-CTA-decouvrir-agence', $(this).data('agency'));
      });
      $('.single-shop__appointment-btn').on('click', function () {
        App.sendEvent('clic-detail-agence', 'clic-CTA-decouvrir-agence', $(this).data('agency'));
      });
      $('.single-shop__mail-btn').on('click', function () {
        App.sendEvent('clic-detail-agence', 'clic-CTA-decouvrir-agence', $(this).data('agency'));
      });

      $(document).on('nfFormSubmitResponse', function (event, response) {
        if (!!document.querySelector('.header') && !!document.querySelector('#postuler')) {
          let heightElement = document.querySelector('.header').offsetHeight;
          document.querySelector('#postuler').style.marginTop = heightElement + 100 + "px";
        }

        if (response.id == 4 && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-candidature-spontanee', 'formulaire-candidature-spontanee-OK');
        }
        else if ((response.id == 3 || response.id == 8) && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-postuler-en-ligne', 'formulaire-candidature-OK');
        }
        else if (response.id == 1 && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-contact', 'formulaire-contact-OK');
          App.scroll('body');
        }
        else if (response.id == 5 && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-devis', 'formulaire-devis-OK');
          App.scroll('body');
          if (typeof gtag == "function") {
            gtag('event', 'conversion', { 'send_to': 'AW-740396774/FAGHCPip1qEDEOadhuEC' });
          }
        }
        else if (response.id == 6 && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-demande-catalogue', 'formulaire-demande-catalogue-OK');
        }
        else if (response.id == 7 && response.response.errors.length == 0) {
          App.sendEvent('formulaire', 'formulaire-prendre-rdv', 'formulaire-prendre-rdv-OK');
        }
      });
    },

    initHeader: function () {
      var menuHeaderTitle = $('.menu-header__title').text();

      var ps = new PerfectScrollbar('.l-scrollbar', {
        suppressScrollX: true
      });
      var $header = $('.header');
      var headerHeight = $header.height();

      // Open menu
      $('.header__burger-btn').on('click', function () {
        var windowHeight = document.documentElement.clientHeight;
        $('.header__dropdown').css('--height', windowHeight - headerHeight + 'px');
        $('.header__burger-btn').toggleClass('is-active');
        $('body').toggleClass('is-overlayed');
        $('.header__dropdown').toggleClass('is-opened');
      });

      // Shrink header
      var scroll = $(window).scrollTop();
      var oldScroll = $(window).scrollTop();
      $(window).on('scroll', function () {
        window.requestAnimationFrame(function () {
          scroll = $(window).scrollTop();
          if (scroll > 0) {
            $header.toggleClass('is-shrinked', (scroll >= headerHeight));
          }
          if (scroll < oldScroll) {
            $header.removeClass('is-shrinked', (scroll >= headerHeight));
          }
          oldScroll = scroll;
        });
      });
    },


    scrollTopOnPageChange: function () {
      $('.page-numbers').on('click', function () {
        App.scroll($('html'), 0);
      });
    },

    initScrollToMe: function () {
      $(window).on('scroll', function () {
        window.requestAnimationFrame(function () {
          var scroll = $(window).scrollTop();
          var height = $(window).outerHeight();
          $('.js-scroll-to-me').each(function () {
            var $link = $(this);
            var $target = $($link.attr('href'));
            if ($target.length) {
              $link.toggleClass('is-hidden', (($target.offset().top - scroll) < (height / 2)));
            }
          });
        });
      });
    },

    disableScrolling: function() {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    },

    enableScrolling: function() {
      document.documentElement.style.overflow = null;
      document.documentElement.style.paddingRight = null;
    },

  };
  // ---------- APP END

  // Init app
  $(App.init);
  $(window).on('load', App.load);

})(jQuery);
